module.exports = __webpack_public_path__ + "img/09.193e0f0b.gif";